import { __isMock__, AssetRepositoryType, ConfigTokens } from './configs/config';
import { MockUser } from './mock/MockUser';
import { MockToken } from './mock/MockToken';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { StoreKey } from './configs/api';
import { Platform } from "react-native";
export var USERTYPE;
(function (USERTYPE) {
    USERTYPE["BORROWER"] = "BORROWER";
    USERTYPE["PARTNER"] = "PARTNER";
})(USERTYPE || (USERTYPE = {}));
export var BUILD_TYPE;
(function (BUILD_TYPE) {
    BUILD_TYPE["BORROWER_PRODUCTION"] = "BORROWER_PRODUCTION";
    BUILD_TYPE["BORROWER_STAGING"] = "BORROWER_STAGING";
    BUILD_TYPE["PARTNER_PRODUCTION"] = "PARTNER_PRODUCTION";
    BUILD_TYPE["PARTNER_STAGING"] = "PARTNER_STAGING";
    BUILD_TYPE["PLATFORM_STAGING"] = "PLATFORM_STAGING";
    BUILD_TYPE["PLATFORM_PRODUCTION"] = "PLATFORM_PRODUCTION";
    BUILD_TYPE["BORROWER_TEST_STAGING"] = "BORROWER_TEST_STAGING";
    BUILD_TYPE["BORROWER_QA_STAGING"] = "BORROWER_QA_STAGING";
    BUILD_TYPE["BORROWER_LOS_STAGING"] = "BORROWER_LOS_STAGING";
    BUILD_TYPE["BORROWER_LMS_STAGING"] = "BORROWER_LMS_STAGING";
})(BUILD_TYPE || (BUILD_TYPE = {}));
const _globalPropsReset = {
    buildType: BUILD_TYPE.PARTNER_PRODUCTION,
    user: {},
    partnerUser: {
        name: '',
        panNumber: '',
        phoneNumber: '',
        emailId: '',
    },
    access_token: null,
    availableAuthCasMap: {},
    accountNumber: '',
    userType: USERTYPE.BORROWER,
    applicationId: '',
    bankCode: '',
    showLogout: true,
    bankName: '',
    primaryLoader: '',
    secondaryLoader: '',
    accountId: '',
    pbankAccNo: '',
    pconfirmAccNo: '',
    pbankIfsc: '',
    allowHome: true,
    portfolioData: [],
    totalAvailableCreditAmount: 0,
    totalAvailableFundAmount: 0,
    url: '',
    bankData: {
        bankName: '',
        bankCode: '',
        accountNumber: '',
        confirmAccountNumber: '',
        bankIfsc: '',
    },
    basicData: {
        panNumber: '',
        mobileNumber: '',
        email: '',
        dob: '',
    },
    basicData_pan: '',
    basicData_dob: '',
    fireBaseConfig: {
        enable_mfd_link_share: false,
        enable_mfd_link_share_test_numbers: '',
        loan_renewal_date: '30',
        loan_renewal_feature_enabled: true,
        loan_renewal_feature_enabled_tata: false,
        loan_renewal_penal_interest: 2,
        loan_renewal_penal_interest_tata: 3,
        loan_renewal_expiry_days: 7,
        loan_tenure_BAJAJ: 1,
        loan_tenure_TATA: 3,
        test_numbers_renewal: '',
        rta_priority: "CAMS",
        show_new_withdraw_flow: false,
        show_new_withdraw_flow_test_numbers: '',
        loan_renewal_repayment_date_BAJAJ: '0',
        loan_renewal_repayment_date_TATA: '0',
        loan_renewal_admin_allow: false,
        contact_support_number: "9611749097",
        loan_renewal_test_flag: false,
        loan_renewal_test_current_date: '',
        test_current_date: '',
        test_current_date_sagar: '',
        earnings_report_month: '',
        earnings_report_year: '',
        plj_app_url: undefined,
        loan_renewal_admin_allow_test_numbers: '',
        SHOW_NEW_DASHBOARD_WITHDRAW_CARD: false,
        show_new_withdraw_temp_date: 0,
        capital_gain_financial_year: '',
        show_rm_contact_button: false,
        show_rm_contact_button_test_number: '',
        show_interest_repayment: false,
        foreclosure_tracking_numbers: '',
        RTA_fetch_error_handle_flag: false,
        show_new_mandate_error_flow: false,
        RTA_fetch_error_handle_numbers: '',
        foreclosure_tracking_flag: false,
        shortfall_card_test_number: '',
        shortfall_card: false,
        shortfall_card_faq: '',
        show_new_mandate_error_flow_test_numbers: '',
        show_intro_page_phonepe: false,
        co_borrower_bajaj_flow: false,
        lein_removal_tracking: '',
        lein_removal_master_config: false,
        partner_dashboard_card_details: '',
        partner_referred_partner_sidenav_title: '',
        partner_referred_partner_reward_structure: '',
        partner_referred_partner_card_details: '',
        partner_referred_partner_mobilenav_title: '',
        partner_interest_rate: 0,
        contact_support_number_pre_dashboard: '',
        upload_image_via_fetch: false,
        show_interest_calculator_feature: false,
        contact_support_number_whatsapp: '',
        show_new_customer_dashboard: false,
        show_new_customer_dashboard_test_number: '',
        session_cache_flag: false,
        session_cache_test_numbers: '',
        show_NewVerify_AndInterest_Flow: false,
        withdrawal_rejection: false,
        show_new_pending_customer: false,
        show_new_pending_customer_test_numbers: '',
        withdrawal_queries_test_numbers: '',
        extra_outstanding_buffer: 0,
        extra_outstanding_buffer_dsp: 0,
        show_bajaj_pg: false,
        show_bajaj_pg_foreclosure: false,
        show_bajaj_pg_interest: false,
        test_numbers_bajaj_pg: '',
        foreclosure_check_test_numbers: '',
        foreclosure_check: false,
        excess_amount_handling_test_numbers: '',
        excess_amount_handling: false,
        repayment_rejection_test_numbers: '',
        repayment_rejection: false,
        show_support_number_for_all_customer: true,
        show_support_number_for_all_customer_test_numbers: '',
        show_dsp_content: false,
        show_new_congrats_screen: false,
        interestRepaymentDates: 0,
        show_withdraw_opt_message: false,
        show_withdraw_opt_message_test_numbers: '',
        showLoanDetails: false,
        showLoanDetailsTestNumbers: '',
        dynamicCheckLimitFromBE: false,
        dynamicLimitTestNumber: '',
        dynamicCheckLimitFromBE_MFC_check_limit: false,
        show_details_update_tata: false,
        show_details_update_bajaj: false,
        show_details_update_dsp: false,
        show_details_update_test_numbers: '',
        show_newRepayment_tata: false,
        show_newRepayment_bajaj: false,
        show_newRepayment_dsp: false,
        show_newRepayment_test_numbers: '',
        enable_phonePe_sdk: true,
        show_virtualAccountDsp: false,
        bfl_partner_repayment_test_numbers: '',
        bfl_partner_repayment: false,
        show_new_foreclosure_flow: false,
        show_new_foreclosure_flow_test_numbers: '8757200577',
        show_new_foreclosure_flow_bajaj: false,
    },
    basicData_email: '',
    basicData_phone: '',
    authCAS: null,
    ref: '',
    /*** Default asset repository */
    initialAssetRepositoryType: AssetRepositoryType.CAMS,
    assetRepositoryConfig: {
        /*** Sequence of fetching asset repository ***/
        [AssetRepositoryType.KARVY]: {
            isFetched: false,
            isPledgedRequired: false,
            isPledged: false,
            priority: 1,
        },
        [AssetRepositoryType.CAMS]: {
            isFetched: false,
            isPledgedRequired: false,
            isPledged: false,
            priority: 2,
        },
        [AssetRepositoryType.MFCENTRAL]: {
            isFetched: false,
            isPledgedRequired: false,
            isPledged: false,
            priority: 3,
        },
    },
    casListOriginal: [],
    toBePledgedAssets: [],
    isFromNativeSdk: false,
    appPlatform: Platform.OS === 'web' ? 'VOLT_WEB_APP' : 'VOLT_MOBILE_APP',
    config: {
        [ConfigTokens.IS_PAN_EDIT_ALLOWED]: false,
        [ConfigTokens.IS_MF_FETCH_AUTO_TRIGGER_OTP]: false,
        [ConfigTokens.IS_KYC_PHOTO_VERIFICATION]: false,
        [ConfigTokens.IS_MF_FETCH_BACK_ALLOWED]: false,
        [ConfigTokens.MIN_AMOUNT_ALLOWED]: 25000,
        [ConfigTokens.MAX_AMOUNT_ALLOWED]: 20000000,
        [ConfigTokens.IS_RTA_SWITCH_ENABLED]: true,
        [ConfigTokens.IS_FIRST_JOURNEY]: false,
    },
    userDob: '',
    creditLimit: 25000,
    listItemDataCAS: [],
    desiredPortfolio: {},
    stepperData: {},
    investorName: '',
    creditStatus: '',
    partnerLeadsList: { customerMetadataList: [], nextToken: null },
    PartnerActiveCustomerList: { customerMetadataList: [], nextToken: null },
    PartnerSideBarActiveId: '',
    ReferredPartnerData: [],
    ifscValue: '',
    PartnerCacheExpireTime: {
        ActiveCustomerCacheExpireTime: null,
        LeadsCacheExpireTime: null,
        ReferredPartnerCacheExpireTime: null,
    },
    registerLeadButtonActive: false,
    marketingLeadsData: {
        fullName: '',
        phoneNumber: '',
        assetDetail: '',
        haveMutualFunds: ''
    },
    showAskMF: false,
    checkLimitInitData: {
        pan: '',
        phoneNumber: ''
    },
    customerLeadAssetData: {},
    mfCentralInitResponse: {},
    partnerAccountId: '',
    source: '',
    photoSource: undefined,
    userDobFromCalenderPicker: '',
    numberOfPhotoVerificationRetries: 1,
    stampDutyData: {},
    numberOfOtpDigits: 6,
    showHome: true,
    loanRenewal: {
        actualLoanAmount: 0,
        loanExpiryDays: 0,
        renewalDate: 0,
    },
    isRepaymentAfterExpiry: false,
    isRenewalAfterExpiry: false,
    foreClosureDetails: undefined,
    is_fire_base_initialized: false,
    isLoanExpired: false,
    isLoanRenewalInProgress: false,
    creditData: undefined,
    collateralData: [],
    presentationMaterialData: [],
    isLoanRenewalRepaymentActive: false,
    selectedCollateralCategory: 0,
    cgtcUserContext: undefined,
    isJointHolderOpened: false,
    isFetchedErrorShowOnce: false,
    isRTAError: false,
    rtaModalBGColor: undefined,
    selectedCollateralCategoryName: '',
    isFromNativeSDK: false,
    pledgeData: undefined,
    showEnableLimit: false,
    showVoltBottomNavBar: true,
    showPoweredByVoltMoney: true,
    showPostLoanJourney: true,
    showMyAccountIcon: true,
    showDashboardManageFields: false,
    showDashboardBenefitsForYou: true,
    showCSPill: true,
    customLogoUrl: '',
    customSupportNumber: '',
    showTransactionHistory: false,
    showManageLimit: false,
    showLoanClosure: false,
    showAccountDetails: false,
    waData: '',
    showWA: true,
    showEmail: true,
    showCall: true,
    emailData: '',
    customIconUrl: '',
    callData: '',
    showInterestCalculator: false,
    borrowerUserProfile: undefined,
    manageLimitConfigData: undefined,
    pendingCreditRequestsByCreditIdData: undefined,
    showSupportPhoneNumber: true,
    isInProgressUnpledgingRequest: false,
    minimumEligibleLimitData: undefined,
    mfCentralFetchError: undefined,
    isUserDetailsUpdateInProgress: false,
    userUpdatedValue: '',
    userUpdateType: '',
    paymentData: {
        outstandingAmount: 0,
        isHavingInterestDue: false,
        isHavingShortfall: false,
        interestDue: 0,
        shortfallDue: 0,
        interestMonth: '',
        interestYear: '',
        interestStatus: '',
        interestState: '',
        isMandateSetup: false,
        recomendedShortfallAmount: 0,
        softBreachDate: 2,
        hardBreachDate: 15,
        accountNumber: "",
        bankCode: '',
        autoPayDate: '',
    },
    pollarInterval: undefined,
    customerReason: '',
    customerRemarks: '',
    isElevateFlow: false
};
let _globalProps = {
    buildType: BUILD_TYPE.PARTNER_PRODUCTION,
    user: {},
    partnerUser: {
        name: '',
        panNumber: '',
        phoneNumber: '',
        emailId: '',
    },
    access_token: '',
    availableAuthCasMap: {},
    accountNumber: '',
    userType: USERTYPE.BORROWER,
    applicationId: '',
    bankCode: '',
    showLogout: true,
    bankName: '',
    primaryLoader: '',
    secondaryLoader: '',
    accountId: '',
    pbankAccNo: '',
    pconfirmAccNo: '',
    pbankIfsc: '',
    allowHome: true,
    portfolioData: [],
    totalAvailableCreditAmount: 0,
    totalAvailableFundAmount: 0,
    url: '',
    bankData: {
        bankName: '',
        bankCode: '',
        accountNumber: '',
        confirmAccountNumber: '',
        bankIfsc: '',
    },
    basicData: {
        panNumber: '',
        mobileNumber: '',
        email: '',
        dob: '',
    },
    basicData_pan: '',
    basicData_dob: '',
    fireBaseConfig: {
        enable_mfd_link_share: false,
        enable_mfd_link_share_test_numbers: '',
        loan_renewal_date: '30',
        loan_renewal_feature_enabled: true,
        loan_renewal_feature_enabled_tata: false,
        loan_renewal_penal_interest: 2,
        loan_renewal_penal_interest_tata: 3,
        loan_renewal_expiry_days: 7,
        loan_tenure_BAJAJ: 1,
        loan_tenure_TATA: 3,
        test_numbers_renewal: '',
        rta_priority: "CAMS",
        show_new_withdraw_flow: false,
        show_new_withdraw_flow_test_numbers: '',
        loan_renewal_repayment_date_BAJAJ: '0',
        loan_renewal_repayment_date_TATA: '0',
        loan_renewal_admin_allow: false,
        contact_support_number: "9611749097",
        loan_renewal_test_flag: false,
        loan_renewal_test_current_date: '',
        test_current_date: '',
        test_current_date_sagar: '',
        earnings_report_month: '',
        earnings_report_year: '',
        plj_app_url: null,
        loan_renewal_admin_allow_test_numbers: '',
        SHOW_NEW_DASHBOARD_WITHDRAW_CARD: false,
        show_new_withdraw_temp_date: 0,
        capital_gain_financial_year: '',
        show_rm_contact_button: false,
        show_rm_contact_button_test_number: '',
        show_interest_repayment: false,
        foreclosure_tracking_numbers: '',
        RTA_fetch_error_handle_flag: false,
        show_new_mandate_error_flow: false,
        RTA_fetch_error_handle_numbers: '',
        foreclosure_tracking_flag: false,
        shortfall_card_test_number: '',
        shortfall_card: false,
        shortfall_card_faq: '',
        show_new_mandate_error_flow_test_numbers: '',
        show_intro_page_phonepe: false,
        co_borrower_bajaj_flow: false,
        lein_removal_tracking: '',
        lein_removal_master_config: false,
        partner_dashboard_card_details: '',
        partner_referred_partner_sidenav_title: '',
        partner_referred_partner_reward_structure: '',
        partner_referred_partner_card_details: '',
        partner_referred_partner_mobilenav_title: '',
        partner_interest_rate: 0,
        contact_support_number_pre_dashboard: '',
        upload_image_via_fetch: false,
        show_interest_calculator_feature: false,
        contact_support_number_whatsapp: '',
        show_new_customer_dashboard: false,
        show_new_customer_dashboard_test_number: '',
        session_cache_flag: false,
        session_cache_test_numbers: '',
        show_NewVerify_AndInterest_Flow: false,
        withdrawal_rejection: false,
        show_new_pending_customer: false,
        show_new_pending_customer_test_numbers: '',
        withdrawal_queries_test_numbers: '',
        extra_outstanding_buffer: 0,
        extra_outstanding_buffer_dsp: 0,
        show_bajaj_pg: false,
        show_bajaj_pg_foreclosure: false,
        show_bajaj_pg_interest: false,
        test_numbers_bajaj_pg: '',
        foreclosure_check_test_numbers: '',
        foreclosure_check: false,
        excess_amount_handling_test_numbers: '',
        excess_amount_handling: false,
        repayment_rejection_test_numbers: '',
        repayment_rejection: false,
        show_support_number_for_all_customer: true,
        show_support_number_for_all_customer_test_numbers: '',
        show_dsp_content: false,
        show_new_congrats_screen: false,
        interestRepaymentDates: 0,
        show_withdraw_opt_message: false,
        show_withdraw_opt_message_test_numbers: '',
        showLoanDetails: false,
        showLoanDetailsTestNumbers: '',
        dynamicCheckLimitFromBE: false,
        dynamicLimitTestNumber: '',
        dynamicCheckLimitFromBE_MFC_check_limit: false,
        show_details_update_tata: false,
        show_details_update_bajaj: false,
        show_details_update_dsp: false,
        show_details_update_test_numbers: '',
        show_newRepayment_tata: false,
        show_newRepayment_bajaj: false,
        show_newRepayment_dsp: false,
        show_newRepayment_test_numbers: '',
        enable_phonePe_sdk: true,
        show_virtualAccountDsp: false,
        bfl_partner_repayment_test_numbers: '',
        bfl_partner_repayment: false,
        show_new_foreclosure_flow: false,
        show_new_foreclosure_flow_test_numbers: '8757200577',
        show_new_foreclosure_flow_bajaj: false,
    },
    basicData_email: '',
    basicData_phone: '',
    authCAS: null,
    ref: '',
    /*** Default asset repository */
    initialAssetRepositoryType: AssetRepositoryType.CAMS,
    assetRepositoryConfig: {
        /*** Sequence of fetching asset repository ***/
        [AssetRepositoryType.KARVY]: {
            isFetched: false,
            isPledgedRequired: false,
            isPledged: false,
            priority: 1,
        },
        [AssetRepositoryType.CAMS]: {
            isFetched: false,
            isPledgedRequired: false,
            isPledged: false,
            priority: 2,
        },
        [AssetRepositoryType.MFCENTRAL]: {
            isFetched: false,
            isPledgedRequired: false,
            isPledged: false,
            priority: 3,
        },
    },
    casListOriginal: [],
    toBePledgedAssets: [],
    isFromNativeSdk: false,
    appPlatform: Platform.OS === 'web' ? 'VOLT_WEB_APP' : 'VOLT_MOBILE_APP',
    config: {
        [ConfigTokens.IS_PAN_EDIT_ALLOWED]: false,
        [ConfigTokens.IS_MF_FETCH_AUTO_TRIGGER_OTP]: false,
        [ConfigTokens.IS_KYC_PHOTO_VERIFICATION]: false,
        [ConfigTokens.IS_MF_FETCH_BACK_ALLOWED]: false,
        [ConfigTokens.MIN_AMOUNT_ALLOWED]: 25000,
        [ConfigTokens.MAX_AMOUNT_ALLOWED]: 20000000,
        [ConfigTokens.IS_RTA_SWITCH_ENABLED]: true,
        [ConfigTokens.IS_FIRST_JOURNEY]: false,
    },
    userDob: '',
    creditLimit: 25000,
    listItemDataCAS: [],
    desiredPortfolio: {},
    stepperData: {},
    investorName: '',
    creditStatus: '',
    partnerLeadsList: { customerMetadataList: [], nextToken: null },
    PartnerActiveCustomerList: { customerMetadataList: [], nextToken: null },
    PartnerSideBarActiveId: '',
    ReferredPartnerData: [],
    ifscValue: '',
    PartnerCacheExpireTime: {
        ActiveCustomerCacheExpireTime: null,
        LeadsCacheExpireTime: null,
        ReferredPartnerCacheExpireTime: null,
    },
    registerLeadButtonActive: false,
    marketingLeadsData: {
        fullName: '',
        phoneNumber: '',
        assetDetail: '',
        haveMutualFunds: ''
    },
    showAskMF: false,
    checkLimitInitData: {
        pan: '',
        phoneNumber: ''
    },
    customerLeadAssetData: {},
    mfCentralInitResponse: {},
    partnerAccountId: '',
    source: '',
    photoSource: undefined,
    userDobFromCalenderPicker: '',
    numberOfPhotoVerificationRetries: 1,
    stampDutyData: {},
    numberOfOtpDigits: 6,
    showHome: true,
    loanRenewal: {
        actualLoanAmount: 0,
        loanExpiryDays: 0,
        renewalDate: 0,
    },
    isRepaymentAfterExpiry: false,
    isRenewalAfterExpiry: false,
    foreClosureDetails: undefined,
    is_fire_base_initialized: false,
    isLoanExpired: false,
    isLoanRenewalInProgress: false,
    creditData: undefined,
    collateralData: [],
    presentationMaterialData: [],
    isLoanRenewalRepaymentActive: false,
    selectedCollateralCategory: 0,
    cgtcUserContext: undefined,
    isJointHolderOpened: false,
    isFetchedErrorShowOnce: false,
    isRTAError: false,
    rtaModalBGColor: undefined,
    selectedCollateralCategoryName: '',
    isFromNativeSDK: false,
    pledgeData: undefined,
    showEnableLimit: false,
    showVoltBottomNavBar: true,
    showPoweredByVoltMoney: true,
    showPostLoanJourney: true,
    showMyAccountIcon: true,
    showDashboardManageFields: false,
    showDashboardBenefitsForYou: true,
    showCSPill: true,
    customLogoUrl: '',
    customSupportNumber: '',
    showTransactionHistory: false,
    showManageLimit: false,
    showLoanClosure: false,
    showAccountDetails: false,
    waData: '',
    showWA: true,
    showEmail: true,
    showCall: true,
    emailData: '',
    customIconUrl: '',
    callData: '',
    showInterestCalculator: false,
    borrowerUserProfile: undefined,
    manageLimitConfigData: undefined,
    pendingCreditRequestsByCreditIdData: undefined,
    showSupportPhoneNumber: true,
    isInProgressUnpledgingRequest: false,
    minimumEligibleLimitData: undefined,
    mfCentralFetchError: undefined,
    isUserDetailsUpdateInProgress: false,
    userUpdatedValue: '',
    userUpdateType: '',
    paymentData: {
        outstandingAmount: 0,
        isHavingInterestDue: false,
        isHavingShortfall: false,
        interestDue: 0,
        shortfallDue: 0,
        interestMonth: '',
        interestYear: '',
        interestStatus: '',
        interestState: '',
        isMandateSetup: false,
        recomendedShortfallAmount: 0,
        softBreachDate: 2,
        hardBreachDate: 15,
        accountNumber: "",
        bankCode: '',
        autoPayDate: '',
    },
    pollarInterval: undefined,
    photoVerifyInitV2: undefined,
    isElevateFlow: false,
};
export function setStepperData(StepperData) {
    _globalProps.stepperData = StepperData;
}
export function getStepperData() {
    return _globalProps.stepperData;
}
export function setURL(url) {
    _globalProps.url = url;
}
export function getURL() {
    return _globalProps.url;
}
export function setInvestorName(investorName) {
    _globalProps.investorName = investorName;
}
export function getInvestorName() {
    return _globalProps.investorName;
}
export function setBuildType(buildType) {
    _globalProps.buildType = buildType;
}
export function getBuildType() {
    return _globalProps.buildType;
}
export function setFirebaseConfig(config) {
    _globalProps.fireBaseConfig = config;
}
export function getFirebaseConfig() {
    return _globalProps.fireBaseConfig;
}
export function setConfig(configId, configValue) {
    // @ts-ignore
    _globalProps.config[configId] = configValue;
}
export function setPrimaryLoader(loaderJson) {
    // @ts-ignore
    _globalProps.primaryLoader = loaderJson;
}
export function setSecondaryLoader(loaderJson) {
    // @ts-ignore
    _globalProps.secondaryLoader = loaderJson;
}
async function getSecondaryLoader() {
    return _globalProps.secondaryLoader;
}
export function getConfig(configId) {
    return configId ? _globalProps.config[configId] : _globalProps.config;
}
/*** Asset repository ***/
async function setAssetRepositoryType(assetRepositoryType) {
    _globalProps.initialAssetRepositoryType = assetRepositoryType;
}
async function isPanValidated() {
    return _globalProps.isPanValidated;
}
async function showHome() {
    return _globalProps.showHome;
}
export function setShowHome(showHome) {
    _globalProps.showHome = showHome;
}
export function setPanValidated(isValidated) {
    _globalProps.isPanValidated = isValidated;
}
async function getAssetRepositoryType() {
    return _globalProps.initialAssetRepositoryType;
}
async function getAssetRepositoryFetchMap() {
    return _globalProps.assetRepositoryConfig;
}
async function setAssetRepositoryFetchMap(value, type) {
    if (type) {
        _globalProps.assetRepositoryConfig[type] = value;
    }
    else {
        _globalProps.assetRepositoryConfig[_globalProps.initialAssetRepositoryType] = value;
    }
}
/*** End Asset repository ***/
async function setBasicData(props) {
    _globalProps.basicData = await props;
}
async function setShowLogout(showLogout) {
    _globalProps.showLogout = await showLogout;
}
async function getShowLogout() {
    return _globalProps.showLogout;
}
async function getBasicData() {
    return _globalProps.basicData;
}
async function setBasicDataPan(basicData_pan) {
    _globalProps.basicData_pan = basicData_pan;
}
async function getBasicDataPan() {
    return _globalProps.basicData_pan;
}
async function setBasicDataEmail(basicData_email) {
    _globalProps.basicData_email = basicData_email;
}
async function setAllowHome(homeAllowed) {
    _globalProps.allowHome = homeAllowed;
}
async function getAllowHome() {
    return _globalProps.allowHome;
}
async function getIsJointHolderOpened() {
    return _globalProps.isJointHolderOpened;
}
async function setIsJointHolderOpened(isJointHolderOpened) {
    _globalProps.isJointHolderOpened = isJointHolderOpened;
}
async function getBasicDataEmail() {
    return _globalProps.isJointHolderOpened;
}
async function setBasicDataDob(basicData_dob) {
    _globalProps.basicData_dob = basicData_dob;
}
async function getBasicDataDob() {
    return _globalProps.basicData_dob;
}
async function setBasicDataPhone(basicData_phone) {
    _globalProps.basicData_phone = basicData_phone;
}
async function getBasicDataPhone() {
    return _globalProps.basicData_phone;
}
async function setBankData(props) {
    _globalProps.bankData = await props;
}
async function getBankData() {
    return _globalProps.bankData;
}
async function setPartnerUser(props) {
    _globalProps.partnerUser = await props;
}
async function getPartnerUser() {
    return _globalProps.partnerUser;
}
async function setAccountId(accountId) {
    _globalProps.accountId = accountId;
}
async function getAccountId() {
    return _globalProps.accountId;
}
async function setBankCode(bankCode) {
    _globalProps.bankCode = bankCode;
}
async function getBankCode() {
    return _globalProps.bankCode;
}
async function setApplicationState(applicationState) {
    _globalProps.applicationState = applicationState;
}
async function getApplicationState() {
    return _globalProps.applicationState;
}
async function setBankName(bankName) {
    _globalProps.bankName = bankName;
}
async function getBankName() {
    return _globalProps.bankName;
}
async function setUserType(userType) {
    _globalProps.userType = userType;
}
async function getUserType() {
    return _globalProps.userType;
}
async function setApplicationId(applicationId) {
    _globalProps.applicationId = applicationId;
}
async function getApplicationId() {
    return _globalProps.applicationId;
}
async function setAccountNumber(accountNumber) {
    _globalProps.accountNumber = accountNumber;
}
async function getAccountNumber() {
    return _globalProps.accountNumber;
}
async function setGlobalProps(props) {
    _globalProps = await props;
}
async function getPartnerRefCode() {
    return _globalProps.ref;
}
async function setPartnerRefCode(ref) {
    _globalProps.ref = ref;
}
async function getSelectedCollateralCategory() {
    return _globalProps.selectedCollateralCategory;
}
async function setSelectedCollateralCategory(selectedCollateralCategory) {
    _globalProps.selectedCollateralCategory = selectedCollateralCategory;
}
async function getSelectedCollateralCategoryName() {
    return _globalProps.selectedCollateralCategoryName;
}
async function setSelectedCollateralCategoryName(selectedCollateralCategoryName) {
    _globalProps.selectedCollateralCategoryName = selectedCollateralCategoryName;
}
async function getMarketingLeadsData() {
    return _globalProps.marketingLeadsData;
}
async function setMarketingLeadsData(data) {
    _globalProps.marketingLeadsData = data;
}
async function getUrlParams() {
    const timestamp = new Date().getTime();
    const urlWithDate = await AsyncStorage.getItem(StoreKey.urlWithDate);
    if (urlWithDate && urlWithDate.includes('&timestamp=')) {
        const dataArray = urlWithDate.split('&timestamp=');
        const time = parseInt(dataArray[1]) || 0;
        if (time) {
            const diff = timestamp - time;
            if (diff > 2419200000) {
                return null;
            }
            else {
                return dataArray[0];
            }
        }
        else {
            return null;
        }
    }
    else {
        return null;
    }
}
async function setUrlParams(url) {
    if (url.includes('utm_source=') ||
        url.includes('utm_medium=') ||
        url.includes('utm_campaign=') ||
        url.includes('utm_content=') ||
        url.includes('utm_id=') ||
        url.includes('utm_term=')) {
        const urlWithDate = url + '&timestamp=' + new Date().getTime();
        await AsyncStorage.setItem(StoreKey.urlWithDate, urlWithDate);
    }
}
function getPropsValue(key) {
    if (_globalProps && key) {
        return _globalProps[key];
    }
    return null;
}
async function setUser(user) {
    _globalProps.user = await user;
}
async function setCollateralsData(collateralData) {
    _globalProps.collateralData = await collateralData;
}
async function getCollateralsData() {
    return _globalProps.collateralData;
}
async function setPresentationMaterialData(presentationMaterialData) {
    _globalProps.presentationMaterialData = await presentationMaterialData;
}
async function getPresentationMaterialData() {
    return _globalProps.presentationMaterialData;
}
async function setFilteredList(filteredList) {
    _globalProps.filteredList = filteredList;
}
async function getFilteredList() {
    return _globalProps.filteredList;
}
async function setIsFromEnhanceLimit(isFromEnhancedLimit) {
    _globalProps.isFromEnhancedLimit = isFromEnhancedLimit;
}
async function getIsFromEnhancedLimit() {
    return _globalProps.isFromEnhancedLimit;
}
async function getUser() {
    if (__isMock__) {
        return MockUser;
    }
    if (Object.values(_globalProps.user).length > 0) {
        return _globalProps.user;
    }
    return null;
}
async function setToken(access_token) {
    _globalProps.access_token = access_token;
    // Set token in cookie
    if (Platform.OS === 'web') {
        // Set expiration date to 1 year from now
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 30);
        // Convert expiration date to UTC string format
        const expires = expirationDate.toUTCString();
        // Set the cookie with expiration date
        document.cookie = `access_token=${access_token}; expires=${expires}; path=/;${window.location.protocol === 'https:' ? 'secure;SameSite=None' : ''};`;
        if (document.cookie.indexOf("access_token") === -1) {
            AsyncStorage.setItem(StoreKey.accessToken, access_token);
        }
    }
    else {
        AsyncStorage.setItem(StoreKey.accessToken, access_token);
    }
}
async function setDisbursalAmount(amount) {
    _globalProps.amount = amount;
}
async function getDisbursalAmount() {
    return _globalProps.amount;
}
async function clearGlobalPropstoken() {
    const preservedKey = "fireBaseConfig"; // keep this key
    const preservedValue = _globalProps[preservedKey]; // Save its value
    _globalProps = { ..._globalPropsReset };
    _globalProps[preservedKey] = preservedValue;
}
async function getToken() {
    if (__isMock__) {
        return MockToken;
    }
    if (_globalProps && (_globalProps?.access_token !== '' && _globalProps?.access_token !== null) && Platform.OS === 'web' && window.self !== window.top) {
        return _globalProps?.access_token;
    }
    // Retrieve token from cookie
    if (Platform.OS === 'web') {
        const cookies = document.cookie.split(';');
        for (const cookie of cookies) {
            const [name, value] = cookie.trim().split('=');
            if (name === 'access_token') {
                _globalProps.access_token = value;
                return value;
            }
        }
    }
    else {
        const token = await AsyncStorage.getItem(StoreKey.accessToken);
        _globalProps.access_token = token;
        if (token)
            return token;
    }
    return null;
}
async function setAvailableCASMap(availableAuthCasMap) {
    _globalProps.availableAuthCasMap = availableAuthCasMap;
}
async function getAvailableCASMap() {
    return _globalProps.availableAuthCasMap;
}
async function setToBePledgedAssets(toBePledgedAssets) {
    _globalProps.toBePledgedAssets = toBePledgedAssets;
}
async function getToBePledgedAssets() {
    return _globalProps.toBePledgedAssets;
}
async function setOnboarding(boolean) {
    // isOnboardingSeen.seen = boolean;
    await AsyncStorage.setItem(StoreKey.isLoadedFirstTime, JSON.stringify(boolean));
}
async function getOnboarding() {
    return await AsyncStorage.getItem(StoreKey.isLoadedFirstTime);
}
async function setPledgeFirstTime(boolean) {
    await AsyncStorage.setItem(StoreKey.isPledgeFirstTime, JSON.stringify(boolean));
}
async function isPledgeFirstTime() {
    const isFirstTime = await AsyncStorage.getItem(StoreKey.isPledgeFirstTime);
    return isFirstTime === null ? true : JSON.parse(isFirstTime);
}
async function setCasListOriginal(casListOriginal) {
    _globalProps.casListOriginal = casListOriginal;
}
async function getCasListOriginal() {
    return _globalProps.casListOriginal;
}
async function setAppPlatform(type) {
    _globalProps.appPlatform = type;
}
async function getAppPlatform() {
    return _globalProps.appPlatform;
}
async function setUserDob(type) {
    _globalProps.userDob = type;
}
async function getUserDob() {
    return _globalProps.userDob;
}
async function setAuthCASResponse(data) {
    _globalProps.authCAS = data;
}
async function getAuthCASResponse() {
    return _globalProps.authCAS;
}
async function setCreditLimit(creditLimit) {
    _globalProps.creditLimit = creditLimit;
}
async function getCreditLimit() {
    return _globalProps.creditLimit;
}
async function setListItemDataCAS(listItemsDataCAS) {
    _globalProps.listItemDataCAS = listItemsDataCAS;
}
async function getListItemDataCAS() {
    return _globalProps.listItemDataCAS;
}
async function setDesiredPortfolio(desiredPortfolio) {
    _globalProps.desiredPortfolio = desiredPortfolio;
}
async function getDesiredPortfolio() {
    return _globalProps.desiredPortfolio;
}
async function setCreditStatus(creditStatus) {
    _globalProps.creditStatus = creditStatus;
}
async function getCreditStatus() {
    return _globalProps.creditStatus;
}
async function setActiveCustomersList(partnerLeadsList) {
    _globalProps.platformActiveCustomersList = partnerLeadsList;
    await AsyncStorage.setItem(StoreKey.PLATFORM_ACTIVE_CUSTOMERS, JSON.stringify(partnerLeadsList));
}
async function setLinkedPartnersList(partnerLeadsList) {
    _globalProps.platformLinkedPartners = partnerLeadsList;
    await AsyncStorage.setItem(StoreKey.PLATFORM_LINKED_PARTNERS, JSON.stringify(partnerLeadsList));
}
async function setPlatformLeadsList(partnerLeadsList) {
    _globalProps.platformLeadsList = partnerLeadsList;
    await AsyncStorage.setItem(StoreKey.Platform_leads, JSON.stringify(partnerLeadsList));
}
async function getLinkedPartnersList() {
    return JSON.parse(await AsyncStorage.getItem(StoreKey.PLATFORM_LINKED_PARTNERS));
}
async function getActiveCustomersList() {
    return JSON.parse(await AsyncStorage.getItem(StoreKey.PLATFORM_ACTIVE_CUSTOMERS));
}
async function getPlatformLeadsList() {
    return JSON.parse(await AsyncStorage.getItem(StoreKey.Platform_leads));
}
async function setPartnerLeadsList(partnerLeadsList) {
    _globalProps.partnerLeadsList = partnerLeadsList;
}
async function getPartnerLeadsList() {
    return _globalProps.partnerLeadsList;
}
async function setPartnerActiveCustomerList(PartnerActiveCustomerList) {
    _globalProps.PartnerActiveCustomerList = PartnerActiveCustomerList;
}
async function getPartnerActiveCustomerList() {
    return _globalProps.PartnerActiveCustomerList;
}
async function setPartnerSideBarActiveId(activeId) {
    _globalProps.PartnerSideBarActiveId = activeId;
}
async function setIfsc(ifsc) {
    _globalProps.ifscValue = ifsc;
}
async function getIfsc() {
    return _globalProps.ifscValue;
}
async function getPartnerSideBarActiveId() {
    return _globalProps.PartnerSideBarActiveId;
}
async function setReferredPartnerData(referredPartnerData) {
    _globalProps.ReferredPartnerData = referredPartnerData;
}
async function getReferredPartnerData() {
    return _globalProps.ReferredPartnerData;
}
async function setIsFromNativeSDK(isFromNativeSDK) {
    _globalProps.isFromNativeSDK = isFromNativeSDK;
}
async function getIsFromNativeSDK() {
    return _globalProps.isFromNativeSDK;
}
async function setPartnerCacheExpireTime(newPartnerCacheExpireTime) {
    _globalProps.PartnerCacheExpireTime = newPartnerCacheExpireTime;
}
async function getPartnerCacheExpireTime() {
    return _globalProps.PartnerCacheExpireTime;
}
async function setRegisterLeadButtonActive(registerLeadButtonActive) {
    _globalProps.registerLeadButtonActive = registerLeadButtonActive;
}
async function getRegisterLeadButtonActive() {
    return _globalProps.registerLeadButtonActive;
}
async function setShowAskMF(showAskMF) {
    _globalProps.showAskMF = showAskMF;
}
async function getShowAskMF() {
    return _globalProps.showAskMF;
}
async function setCheckLimitInitData(checkLimitInitData) {
    _globalProps.checkLimitInitData = checkLimitInitData;
}
async function getCheckLimitInitData() {
    return _globalProps.checkLimitInitData;
}
async function getCustomerLeadAssetData() {
    return _globalProps.customerLeadAssetData;
}
async function setCustomerLeadAssetData(customerLeadAssetData) {
    _globalProps.customerLeadAssetData = customerLeadAssetData;
}
async function setMfCentralInitResponse(mfCentralInitResponse) {
    _globalProps.mfCentralInitResponse = mfCentralInitResponse;
}
async function getMfCentralInitResponse() {
    return _globalProps.mfCentralInitResponse;
}
async function setPartnerAccountId(partnerAccountId) {
    _globalProps.partnerAccountId = partnerAccountId;
}
async function getPartnerAccountId() {
    return _globalProps.partnerAccountId;
}
async function setSource(source) {
    _globalProps.source = source;
}
async function setPortfolioData(data) {
    _globalProps.portfolioData = data;
}
async function getTotalCreditAmount() {
    return _globalProps.totalAvailableCreditAmount;
}
async function setTotalCreditAmount(totalAvailableCreditAmount) {
    _globalProps.totalAvailableCreditAmount = totalAvailableCreditAmount;
}
async function getTotalFundAmount() {
    return _globalProps.totalAvailableFundAmount;
}
async function setTotalFundAmount(totalAvailableFundAmount) {
    _globalProps.totalAvailableFundAmount = totalAvailableFundAmount;
}
async function getPortfiolioData() {
    return _globalProps.portfolioData;
}
async function getSource() {
    return _globalProps.source;
}
async function setPhotoSource(photoSource) {
    _globalProps.photoSource = photoSource;
}
async function getPhotoSource() {
    return _globalProps.photoSource;
}
async function setUserDobFromCalenderPicker(userDobFromCalenderPicker) {
    _globalProps.userDobFromCalenderPicker = userDobFromCalenderPicker;
}
async function getUserDobFromCalenderPicker() {
    return _globalProps.userDobFromCalenderPicker;
}
// numberOfPhotoVerificationRetries
async function setNumberOfPhotoVerificationRetries() {
    _globalProps.numberOfPhotoVerificationRetries += 1;
}
async function getNumberOfPhotoVerificationRetries() {
    return _globalProps.numberOfPhotoVerificationRetries;
}
async function setStampDutyData(_stampDutyData) {
    _globalProps.stampDutyData = _stampDutyData;
}
async function getStampDutyData() {
    return _globalProps.stampDutyData;
}
async function setNumberOfOtpDigits(_numberOfOtpDigits) {
    _globalProps.numberOfOtpDigits = _numberOfOtpDigits;
}
async function getNumberOfOtpDigits() {
    return _globalProps.numberOfOtpDigits;
}
async function setLoanRenewalData(loanRenewal) {
    _globalProps.loanRenewal = loanRenewal;
}
async function getLoanRenewalData() {
    return _globalProps.loanRenewal;
}
async function getIsRepaymentAfterExpiry() {
    return _globalProps.isRepaymentAfterExpiry;
}
async function setIsRepaymentAfterExpiry(isRepaymentAfterExpiry) {
    _globalProps.isRepaymentAfterExpiry = isRepaymentAfterExpiry;
}
async function getIsRenewalAfterExpiry() {
    return _globalProps.isRenewalAfterExpiry;
}
async function setIsRenewalAfterExpiry(isRenewalAfterExpiry) {
    _globalProps.isRenewalAfterExpiry = isRenewalAfterExpiry;
}
async function getForeClosureDetails() {
    return _globalProps.foreClosureDetails;
}
async function setForeClosureDetails(foreClosureDetails) {
    _globalProps.foreClosureDetails = foreClosureDetails;
}
async function getIsFireBaseInitialized() {
    return _globalProps.is_fire_base_initialized;
}
async function setIsFireBaseInitialized(is_fire_base_initialized) {
    _globalProps.is_fire_base_initialized = is_fire_base_initialized;
}
async function getIsLoanExpired() {
    return _globalProps.isLoanExpired;
}
async function setIsLoanExpired(isLoanExpired) {
    _globalProps.isLoanExpired = isLoanExpired;
}
async function getIsInProgressLoanRenewal() {
    return _globalProps.isLoanRenewalInProgress;
}
async function setIsInProgressLoanRenewal(isLoanRenewalInProgress) {
    _globalProps.isLoanRenewalInProgress = isLoanRenewalInProgress;
}
async function getCreditData() {
    return _globalProps.creditData;
}
async function setCreditData(creditData) {
    _globalProps.creditData = creditData;
}
async function getIsLoanRenewalRepaymentActive() {
    return _globalProps.isLoanRenewalRepaymentActive;
}
async function setIsLoanRenewalRepaymentActive(isLoanRenewalRepaymentActive) {
    _globalProps.isLoanRenewalRepaymentActive = isLoanRenewalRepaymentActive;
}
async function getIsFetchedErrorShowOnce() {
    return _globalProps.isFetchedErrorShowOnce;
}
async function setIsFetchedErrorShowOnce(isFetchedErrorShowOnce) {
    _globalProps.isFetchedErrorShowOnce = isFetchedErrorShowOnce;
}
async function getCgtcUserContext() {
    const cgtcUserContext = JSON.parse(await AsyncStorage.getItem(StoreKey.CGTC_USER_CONTEXT));
    return cgtcUserContext;
}
async function setCgtcUserContext(cgtcUserData) {
    await AsyncStorage.setItem(StoreKey.CGTC_USER_CONTEXT, JSON.stringify(cgtcUserData));
}
async function getIsRTAError() {
    return _globalProps.isRTAError;
}
async function setIsRTAError(isRTAError) {
    _globalProps.isRTAError = isRTAError;
}
async function getRtaModalBGColor() {
    return _globalProps.rtaModalBGColor;
}
async function setRtaModalBGColor(rtaModalBGColor) {
    _globalProps.rtaModalBGColor = rtaModalBGColor;
}
async function setPledgeData(pledgeData) {
    _globalProps.pledgeData = pledgeData;
}
async function getPledgeData() {
    return _globalProps.pledgeData;
}
async function setShowEnableLimit(showEnableLimit) {
    _globalProps.showEnableLimit = showEnableLimit;
}
async function showEnableLimit() {
    return _globalProps.showEnableLimit;
}
async function setShowVoltBottomBar(showVoltBottomNavBar) {
    _globalProps.showVoltBottomNavBar = showVoltBottomNavBar;
}
async function getShowVoltBottomBar() {
    return _globalProps.showVoltBottomNavBar;
}
async function setShowPoweredByVoltMoney(showPoweredByVoltMoney) {
    _globalProps.showPoweredByVoltMoney = showPoweredByVoltMoney;
}
async function getShowPoweredByVoltMoney() {
    return _globalProps.showPoweredByVoltMoney;
}
async function setShowPostLoanJourney(showPostLoanJourney) {
    _globalProps.showPostLoanJourney = showPostLoanJourney;
}
async function getShowPostLoanJourney() {
    return _globalProps.showPostLoanJourney;
}
async function setShowMyAccountIcon(showMyAccountIcon) {
    _globalProps.showMyAccountIcon = showMyAccountIcon;
}
async function getShowMyAccountIcon() {
    return _globalProps.showMyAccountIcon;
}
async function setShowDashboardManageFields(showDashboardManageFields) {
    _globalProps.showDashboardManageFields = showDashboardManageFields;
}
async function getShowDashboardManageFields() {
    return _globalProps.showDashboardManageFields;
}
async function setShowDashboardBenefitsForYou(showDashboardBenefitsForYou) {
    _globalProps.showDashboardBenefitsForYou = showDashboardBenefitsForYou;
}
async function getShowDashboardBenefitsForYou() {
    return _globalProps.showDashboardBenefitsForYou;
}
async function setShowCSPill(showCSPill) {
    _globalProps.showCSPill = showCSPill;
}
async function getShowCSPill() {
    return _globalProps.showCSPill;
}
async function setCustomLogoUrl(customLogoUrl) {
    _globalProps.customLogoUrl = customLogoUrl;
}
async function getCustomLogoUrl() {
    return _globalProps.customLogoUrl;
}
async function setCustomSupportNumber(customSupportNumber) {
    _globalProps.customSupportNumber = customSupportNumber;
}
async function getCustomSupportNumber() {
    return _globalProps.customSupportNumber;
}
async function setShowTransactionHistory(showTransactionHistory) {
    _globalProps.showTransactionHistory = showTransactionHistory;
}
async function getShowTransactionHistory() {
    return _globalProps.showTransactionHistory;
}
async function setShowManageLimit(showManageLimit) {
    _globalProps.showManageLimit = showManageLimit;
}
async function getShowManageLimit() {
    return _globalProps.showManageLimit;
}
async function setShowLoanClosure(showLoanClosure) {
    _globalProps.showLoanClosure = showLoanClosure;
}
async function getShowLoanClosure() {
    return _globalProps.showLoanClosure;
}
async function setShowAccountDetails(showAccountDetails) {
    _globalProps.showAccountDetails = showAccountDetails;
}
async function getShowAccountDetails() {
    return _globalProps.showAccountDetails;
}
async function setWAData(waData) {
    _globalProps.waData = waData;
}
async function getWAData() {
    return _globalProps.waData;
}
async function setShowWA(showWA) {
    _globalProps.showWA = showWA;
}
async function getShowWA() {
    return _globalProps.showWA;
}
async function setShowEmail(showEmail) {
    _globalProps.showEmail = showEmail;
}
async function getShowEmail() {
    return _globalProps.showEmail;
}
async function setShowCall(showCall) {
    _globalProps.showCall = showCall;
}
async function getShowCall() {
    return _globalProps.showCall;
}
async function setEmailData(emailData) {
    _globalProps.emailData = emailData;
}
async function getEmailData() {
    return _globalProps.emailData;
}
async function setCustomIconUrl(customIconUrl) {
    _globalProps.customIconUrl = customIconUrl;
}
async function getCustomIconUrl() {
    return _globalProps.customIconUrl;
}
async function setCallData(callData) {
    _globalProps.callData = callData;
}
async function getCallData() {
    return _globalProps.callData;
}
async function setSupportPhoneNumber(showSupportPhoneNumber) {
    _globalProps.showSupportPhoneNumber = showSupportPhoneNumber;
}
async function getSupportPhoneNumber() {
    return _globalProps.showSupportPhoneNumber;
}
async function setUnpledgeRequest(isInProgressUnpledgingRequest) {
    _globalProps.isInProgressUnpledgingRequest = isInProgressUnpledgingRequest;
}
async function getUnpledgeRequest() {
    return _globalProps.isInProgressUnpledgingRequest;
}
async function setIsUserUpdateDetailsInProgress(isUserDetailsUpdateInProgress) {
    _globalProps.isUserDetailsUpdateInProgress = isUserDetailsUpdateInProgress;
}
async function getIsUserUpdateDetailsInProgress() {
    return _globalProps.isUserDetailsUpdateInProgress;
}
async function setUserUpdateType(userUpdateType) {
    _globalProps.userUpdateType = userUpdateType;
}
async function getUserUpdateType() {
    return _globalProps.userUpdateType;
}
async function setUserUpdateValue(userUpdatedValue) {
    _globalProps.userUpdatedValue = userUpdatedValue;
}
async function getUserUpdateValue() {
    return _globalProps.userUpdatedValue;
}
async function setShowInterestCalculator(showInterestCalculator) {
    _globalProps.showInterestCalculator = showInterestCalculator;
}
async function getShowInterestCalculator() {
    return _globalProps.showInterestCalculator;
}
async function setBorrowerUserProfile(borrowerUserProfile) {
    _globalProps.borrowerUserProfile = borrowerUserProfile;
}
async function getBorrowerUserProfile() {
    return _globalProps.borrowerUserProfile;
}
async function setManageLimitConfigData(manageLimitConfigData) {
    _globalProps.manageLimitConfigData = manageLimitConfigData;
}
async function getManageLimitConfigData() {
    return _globalProps.manageLimitConfigData;
}
async function setPendingCreditRequestsByCreditIdData(pendingCreditRequestsByCreditIdData) {
    _globalProps.pendingCreditRequestsByCreditIdData = pendingCreditRequestsByCreditIdData;
}
async function getPendingCreditRequestsByCreditIdData() {
    return _globalProps.pendingCreditRequestsByCreditIdData;
}
async function setMinimumEligibleLimitData(minimumEligibleLimitData) {
    _globalProps.minimumEligibleLimitData = minimumEligibleLimitData;
}
async function getMinimumEligibleLimitData() {
    return _globalProps.minimumEligibleLimitData;
}
async function setMFCentralFetchError(mfCentralFetchError) {
    _globalProps.mfCentralFetchError = mfCentralFetchError;
}
async function getMFCentralFetchError() {
    return _globalProps.mfCentralFetchError;
}
export function setPaymentData(paymentData) {
    _globalProps.paymentData = paymentData;
}
export function getPaymentData() {
    return _globalProps.paymentData;
}
export function setPollarInterval(pollarInterval) {
    _globalProps.pollarInterval = pollarInterval;
}
export function getPollarInterval() {
    return _globalProps.pollarInterval;
}
async function setCustomerRemarks(customerRemarks) {
    _globalProps.customerRemarks = customerRemarks;
}
async function getCustomerRemarks() {
    return _globalProps.customerRemarks;
}
async function setCustomerReason(customerReason) {
    _globalProps.customerReason = customerReason;
}
async function getCustomerReason() {
    return _globalProps.customerReason;
}
async function setPhotoVerifyInitV2(photoVerifyInitV2) {
    _globalProps.photoVerifyInitV2 = photoVerifyInitV2;
}
async function getPhotoVerifyInitV2() {
    return _globalProps.photoVerifyInitV2;
}
async function setElevateFlow(elevate) {
    _globalProps.isElevateFlow = elevate;
}
async function getElevateFlow() {
    return _globalProps.isElevateFlow;
}
export default {
    clearGlobalPropstoken,
    setBuildType,
    getBuildType,
    setGlobalProps,
    getPropsValue,
    setUser,
    getUser,
    setURL,
    getURL,
    setToken,
    getToken,
    setAvailableCASMap,
    getAvailableCASMap,
    setToBePledgedAssets,
    getToBePledgedAssets,
    setOnboarding,
    getOnboarding,
    getAccountNumber,
    setAccountNumber,
    setPledgeFirstTime,
    isPledgeFirstTime,
    setUserType,
    getUserType,
    setPartnerRefCode,
    getPartnerRefCode,
    setApplicationId,
    getApplicationId,
    setBankCode,
    getBankCode,
    setBankName,
    getBankName,
    getAccountId,
    setAccountId,
    setPartnerUser,
    getPartnerUser,
    setBankData,
    getBankData,
    setBasicData,
    getBasicData,
    setAssetRepositoryType,
    getAssetRepositoryType,
    getAssetRepositoryFetchMap,
    setAssetRepositoryFetchMap,
    setCasListOriginal,
    getCasListOriginal,
    setUrlParams,
    getUrlParams,
    setAppPlatform,
    getAppPlatform,
    setConfig,
    getConfig,
    setFirebaseConfig,
    getFirebaseConfig,
    setAuthCASResponse,
    getAuthCASResponse,
    setUserDob,
    getUserDob,
    setCreditLimit,
    getCreditLimit,
    setListItemDataCAS,
    getListItemDataCAS,
    setDesiredPortfolio,
    getDesiredPortfolio,
    setStepperData,
    getStepperData,
    setInvestorName,
    getInvestorName,
    getBasicDataDob,
    setBasicDataDob,
    getBasicDataEmail,
    setBasicDataEmail,
    getBasicDataPan,
    setBasicDataPan,
    getBasicDataPhone,
    setBasicDataPhone,
    setCreditStatus,
    getCreditStatus,
    setPartnerLeadsList,
    getPartnerLeadsList,
    setPartnerActiveCustomerList,
    getPartnerActiveCustomerList,
    setPartnerSideBarActiveId,
    getPartnerSideBarActiveId,
    setReferredPartnerData,
    getReferredPartnerData,
    setIfsc,
    getIfsc,
    setPartnerCacheExpireTime,
    getPartnerCacheExpireTime,
    setRegisterLeadButtonActive,
    getRegisterLeadButtonActive,
    setPlatformLeadsList,
    getPlatformLeadsList,
    setActiveCustomersList,
    getActiveCustomersList,
    setLinkedPartnersList,
    getLinkedPartnersList,
    getMarketingLeadsData,
    setMarketingLeadsData,
    setShowAskMF,
    getShowAskMF,
    setCheckLimitInitData,
    getCheckLimitInitData,
    getCustomerLeadAssetData,
    setCustomerLeadAssetData,
    setMfCentralInitResponse,
    getMfCentralInitResponse,
    setPartnerAccountId,
    getPartnerAccountId,
    setSource,
    getSource,
    setPhotoSource,
    getPhotoSource,
    setUserDobFromCalenderPicker,
    getUserDobFromCalenderPicker,
    getApplicationState,
    setApplicationState,
    setNumberOfPhotoVerificationRetries,
    getNumberOfPhotoVerificationRetries,
    setStampDutyData,
    getStampDutyData,
    setPortfolioData,
    getPortfiolioData,
    setNumberOfOtpDigits,
    getNumberOfOtpDigits,
    setPanValidated,
    isPanValidated,
    setFilteredList,
    getFilteredList,
    setDisbursalAmount,
    getDisbursalAmount,
    setShowLogout,
    getShowLogout,
    setShowHome,
    showHome,
    setIsFromEnhanceLimit,
    getIsFromEnhancedLimit,
    setLoanRenewalData,
    getLoanRenewalData,
    getIsRepaymentAfterExpiry,
    setIsRepaymentAfterExpiry,
    getForeClosureDetails,
    setForeClosureDetails,
    getIsRenewalAfterExpiry,
    setIsRenewalAfterExpiry,
    getIsFireBaseInitialized,
    setIsFireBaseInitialized,
    getIsLoanExpired,
    setIsLoanExpired,
    getIsInProgressLoanRenewal,
    setIsInProgressLoanRenewal,
    getCreditData,
    setCreditData,
    setCollateralsData,
    getCollateralsData,
    setPresentationMaterialData,
    getPresentationMaterialData,
    getIsLoanRenewalRepaymentActive,
    setIsLoanRenewalRepaymentActive,
    setSelectedCollateralCategory,
    getSelectedCollateralCategory,
    getCgtcUserContext,
    setCgtcUserContext,
    getIsJointHolderOpened,
    setIsJointHolderOpened,
    getIsFetchedErrorShowOnce,
    setIsFetchedErrorShowOnce,
    getIsRTAError,
    setIsRTAError,
    getRtaModalBGColor,
    setRtaModalBGColor,
    setSelectedCollateralCategoryName,
    getSelectedCollateralCategoryName,
    setAllowHome,
    getAllowHome,
    setIsFromNativeSDK,
    getIsFromNativeSDK,
    setPledgeData,
    getPledgeData,
    setShowEnableLimit,
    showEnableLimit,
    setShowVoltBottomBar,
    getShowVoltBottomBar,
    setShowPoweredByVoltMoney,
    getShowPoweredByVoltMoney,
    setShowPostLoanJourney,
    getShowPostLoanJourney,
    setShowMyAccountIcon,
    getShowMyAccountIcon,
    setShowDashboardManageFields,
    getShowDashboardManageFields,
    setShowDashboardBenefitsForYou,
    getShowDashboardBenefitsForYou,
    setShowCSPill,
    getShowCSPill,
    setCustomLogoUrl,
    getCustomLogoUrl,
    setCustomSupportNumber,
    getCustomSupportNumber,
    setShowTransactionHistory,
    getShowTransactionHistory,
    setShowManageLimit,
    getShowManageLimit,
    setShowLoanClosure,
    getShowLoanClosure,
    setShowAccountDetails,
    getShowAccountDetails,
    setWAData,
    getWAData,
    setShowWA,
    getShowWA,
    setShowEmail,
    getShowEmail,
    setShowCall,
    getShowCall,
    setEmailData,
    getEmailData,
    setCustomIconUrl,
    getCustomIconUrl,
    setCallData,
    getCallData,
    setShowInterestCalculator,
    getShowInterestCalculator,
    setBorrowerUserProfile,
    getBorrowerUserProfile,
    setManageLimitConfigData,
    getManageLimitConfigData,
    setPendingCreditRequestsByCreditIdData,
    getPendingCreditRequestsByCreditIdData,
    setPrimaryLoader,
    getSecondaryLoader,
    setSecondaryLoader,
    getSupportPhoneNumber,
    setSupportPhoneNumber,
    getTotalCreditAmount,
    setTotalCreditAmount,
    getTotalFundAmount,
    setTotalFundAmount,
    setUnpledgeRequest,
    getUnpledgeRequest,
    setMinimumEligibleLimitData,
    getMinimumEligibleLimitData,
    setMFCentralFetchError,
    getMFCentralFetchError,
    setIsUserUpdateDetailsInProgress,
    getIsUserUpdateDetailsInProgress,
    setUserUpdateType,
    getUserUpdateType,
    setUserUpdateValue,
    getUserUpdateValue,
    setPaymentData,
    getPaymentData,
    setPollarInterval,
    getPollarInterval,
    getCustomerReason,
    setCustomerReason,
    getCustomerRemarks,
    setCustomerRemarks,
    setPhotoVerifyInitV2,
    getPhotoVerifyInitV2,
    setElevateFlow,
    getElevateFlow
};
